module.exports = __webpack_public_path__ + "img/success.fd1fb5ba.png";